// MIT © 2017 azu
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * shouldStateUpdate logic.
 * use Store#shouldStateUpdate if it is implemented in the Store.
 * In other case, use strict equal `===` by default.
 */
exports.shouldStateUpdate = function (store, prevState, nextState) {
    if (typeof store.shouldStateUpdate === "function") {
        return store.shouldStateUpdate(prevState, nextState);
    }
    return prevState !== nextState;
};
//# sourceMappingURL=StoreGroupUtils.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UILayer/StoreGroupUtils.js
// module id = 191
// module chunks = 0